import React, { PropTypes } from "react";

const RectangleSpinner = (props) => {
  const className =
    typeof props.className !== "undefined" ? ` ${props.className}` : "";
  return (
    <div className={`spinner-rect${className}`}>
      <div className="rect1" />
      <div className="rect2" />
      <div className="rect3" />
      <div className="rect4" />
      <div className="rect5" />
    </div>
  );
};

RectangleSpinner.propTypes = {
  className: PropTypes.string,
};

export default RectangleSpinner;



// WEBPACK FOOTER //
// ./src/components/common/spinners/RectangleSpinner.js